import React, { useEffect, useRef } from 'react';

import { mount, unmount } from 'redom';

import NativeSenderButton from './';

function NativeSenderButtonReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeSenderButtonReference = useRef(null);

  useEffect(function onLoad() {

    const container = wrapperMainReference.current;

    const nativeSenderButton = new NativeSenderButton(props);

    nativeSenderButtonReference.current = nativeSenderButton;

    mount(container, nativeSenderButtonReference.current);

    return function onUnload() {

      unmount(container, nativeSenderButton);

    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    nativeSenderButtonReference.current.update(props);

  }, [props]);

  function renderMain() {

    const mainAttributes = {
      className: 'sender-button-native-react-wrapper-main',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  return renderMain();

}

export default NativeSenderButtonReactWrapper;